// extracted by mini-css-extract-plugin
module.exports = {"profile":"styles_profile__3TJpq","info":"styles_info__1pmjc","menu":"styles_menu__3EDGn","container":"styles_container__WB30Y","number":"styles_number__3kwPM"};